'use strict';

/**
 * MylabUtils — Utilitaires partagés MyLab Shop
 * Utilisé par : mylab-product.js, ml-volume-pricing.js, ml-quick-order
 */
(function () {
  var PRODUCT_MAP = null;

  // La promesse est gardée : le panier la demande une fois par ligne, en même temps.
  function loadProductMap() {
    if (PRODUCT_MAP) return PRODUCT_MAP;
    var mapUrl = (window.MylabAssets && window.MylabAssets.productMapUrl) || '/assets/ml-product-map.json';
    PRODUCT_MAP = fetch(mapUrl)
      .then(function (r) { return r.json(); })
      .catch(function (erreur) { PRODUCT_MAP = null; throw erreur; });
    return PRODUCT_MAP;
  }

  function parseTierString(str) {
    if (!str) return [];
    return str.split(',').map(function (t) {
      var p = t.split(':');
      return { qty: parseInt(p[0], 10), price: parseInt(p[1], 10) };
    });
  }

  function findProductEntry(handle, map) {
    if (map[handle]) return { entry: map[handle], size: null };
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      var entry = map[keys[i]];
      var sizes = entry.sizes || {};
      var sizeKeys = Object.keys(sizes);
      for (var s = 0; s < sizeKeys.length; s++) {
        if (sizes[sizeKeys[s]] === handle) {
          return { entry: entry, size: sizeKeys[s] };
        }
      }
    }
    return null;
  }

  function findTiers(handle, map) {
    var found = findProductEntry(handle, map);
    if (!found) return null;
    var entry = found.entry;
    var size = found.size;
    if (!size) {
      var sizeKeys = Object.keys(entry.sizes || {});
      for (var i = 0; i < sizeKeys.length; i++) {
        if (entry.sizes[sizeKeys[i]] === handle) { size = sizeKeys[i]; break; }
      }
      if (!size && sizeKeys.length > 0) size = sizeKeys[0];
    }
    var tierStr = entry.tiers ? entry.tiers[size] : null;
    return tierStr || null;
  }

  /** Retourne {handle} de la pompe pour un format ('200'/'500'/'1000'), ou null.
      Aucune pompe pour un format listé dans entry.no_pump_sizes (pots, sprays). */
  function getPumpForFormat(format, map, entry) {
    if (!map || !map._pumps || !format) return null;
    if (entry && entry.no_pump_sizes && entry.no_pump_sizes.indexOf(String(format)) !== -1) return null;
    return map._pumps[String(format)] || null;
  }

  var PUMP_CACHE = {};
  /** Fetch (mis en cache) le produit pompe Shopify -> { variantId, price, handle } ou null. */
  function loadPumpProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (PUMP_CACHE[handle]) return PUMP_CACHE[handle];
    PUMP_CACHE[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        if (!v || v.available === false) return null;
        return { variantId: v.id, price: v.price, handle: handle };
      })
      .catch(function () { return null; });
    return PUMP_CACHE[handle];
  }

  function formatPrice(centimes) {
    return (centimes / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20ac';
  }

  function formatPriceCompact(centimes) {
    return (centimes / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /** Formatte centimes en "X,XX" (sans symbole €) — utilisé par la commande express */
  function formatPriceRaw(centimes) {
    var e = Math.floor(centimes / 100);
    var c = centimes % 100;
    return e.toLocaleString('fr-FR') + ',' + (c < 10 ? '0' : '') + c;
  }

  window.MylabUtils = {
    loadProductMap: loadProductMap,
    parseTierString: parseTierString,
    findProductEntry: findProductEntry,
    findTiers: findTiers,
    getPumpForFormat: getPumpForFormat,
    loadPumpProduct: loadPumpProduct,
    formatPrice: formatPrice,
    formatPriceCompact: formatPriceCompact,
    formatPriceRaw: formatPriceRaw
  };
})();
